import { render, staticRenderFns } from "./reception_download.vue?vue&type=template&id=2ee7ce39&"
import script from "./reception_download.vue?vue&type=script&lang=js&"
export * from "./reception_download.vue?vue&type=script&lang=js&"
import style0 from "./reception_download.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/魚類販賣系統/shopstore_fish/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ee7ce39')) {
      api.createRecord('2ee7ce39', component.options)
    } else {
      api.reload('2ee7ce39', component.options)
    }
    module.hot.accept("./reception_download.vue?vue&type=template&id=2ee7ce39&", function () {
      api.rerender('2ee7ce39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation_system_finance/components/reception_download.vue"
export default component.exports